import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ProBadgeIcon} from 'shells/icon/svg/pro-badge';
import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {hasEmailSequenceCapability} from './has-email-sequence-capability';

import styles from './email-onboarding-modal.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export class EmailOnboardingModal extends React.PureComponent<Props> {
    render() {
        return (
            <Modal
                onClose={this.props.onClose}
                canClickOutsideToClose={true}
                closeButton={false}
                isOpen={this.props.isOpen}
                noPadding={true}
                maxHeight={500}
            >
                <OnboardingPage
                    type='singlePage'
                    buttonText='Got it'
                    artImage={<Art />}
                    bodyComponent={<Body />}
                    artBackgroundColor={colors.plumLt}
                    onClose={this.props.onClose}
                />
            </Modal>
        );
    }
}

const Body = () => {
    const hasSequences = hasEmailSequenceCapability();

    return (
        <OnboardingBody
            title={
                hasSequences
                    ? 'Introducing automated email follow-up and shared templates'
                    : 'Introducing shared templates'
            }
        >
            {hasSequences ? (
                <div>
                    <p>
                        Nutshell Pro helps you to follow up on the emails you send. Schedule a{' '}
                        <strong>series</strong> of messages, and we’ll send them for you, until your
                        contact replies.
                    </p>
                    <p>
                        And, share your most effective email templates with your company, so
                        everyone can sell at their best.
                    </p>
                </div>
            ) : (
                <div>
                    <p>Nutshell email has gotten more powerful. 💪</p>
                    <p>
                        Now, share your most effective email templates with your company, so
                        everyone can sell at their best.
                    </p>
                    <p>
                        And if you go <ProBadgeIcon size={20} wrapWithDiv={false} />, you’ll be able
                        to automatically send follow-up emails until your contact replies.{' '}
                        <Link href='/setup/billing/sales' newTab={true}>
                            Upgrade now
                        </Link>
                    </p>
                </div>
            )}
        </OnboardingBody>
    );
};
const Art = () => (
    <div className={styles.art}>
        <img
            alt=''
            src='/include/images/email-drip/email-onboarding_2x.png'
            className={styles['large-icon']}
        />
    </div>
);
